module.exports = __webpack_public_path__ + "static/media/design1.8fca083b.gif";